import { OverridableComponent } from "@mui/material/OverridableComponent";
import useStores from "../hooks/use-stores";
import { SvgIconTypeMap } from "@mui/material";

export const PAGE_SIZE = 8;
export const DESKTOP_SIZE = 1536;


export enum Language { ENGLISH = 'en-AU', ZH_CN = 'zh-CN', ZH_TW = 'zh-TW', ZH_HK = 'zh-HK' };
export const LangList = [Language.ENGLISH, Language.ZH_CN, Language.ZH_HK, Language.ZH_TW];

export enum ColorScheme { INITIAL, ERROR, WARNING, SUCCESS, INFO, DISABLED };

export enum BLOG_CATEGORY {
  PUBLIC_CPD = 1,
  EVENT = 3,
  TRAINING_COURSE = 4,
}

